import "./Phonetics.css";

export default function Phonetics(props) {
  //console.log(props.otherInfo);
  function playSound(event) {
    event.preventDefault();
    //console.log(props.otherInfo.phonetics.audio);
    let sound = new Audio(props.otherInfo.phonetics.audio);
    sound.play();
  }
  return (
    <section>
      <h1>{props.word} </h1>
      <button onClick={playSound} className="sound">
        🔊
      </button>{" "}
      <span className="IPA">{props.otherInfo.phonetics.text}</span>
    </section>
  );
}
